import React, { FC, Suspense } from 'react'
import { styled } from '@creditas/stylitas'

import { ContentFetching } from './ContentFetching'
import { EmailAndCellphone } from './EmailAndCellphone'

const Container = styled.div`
  width: 30%;
  max-width: 285px;
  border-right: 1px solid #d8d8d8;

  h3 {
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 12px;
  }
`

const LeadInfo: FC<{
  applicationId: string
  name: string
  cpf: string
}> = ({ applicationId, name, cpf }) => (
  <Container data-testid="lead-info-container">
    <h3>{name}</h3>
    <p>{cpf}</p>
    <Suspense fallback={<ContentFetching />}>
      <EmailAndCellphone applicationId={applicationId} />
    </Suspense>
  </Container>
)

export { LeadInfo }
